import {useMemo} from "react";
import {skipToken} from "@reduxjs/toolkit/query";
import {
  adjustToTimeZone, adjustToTimeZoneSafely,
  ApiError,
  extractApiError,
  locationStatusFacetsSelector,
  ServiceEventType,
  useGetLocationStatusFacetsAtTimeQuery
} from "@ots-frontend/ots-data";
import {buildOpsLocationStatuses, OpsLocationStatus} from "../model/ops-status";

export type UseOpsStatusesProps = {
  pollingInterval?: number,
  dttm?: Date | number
  regionId?: string,
  serviceEventType?: ServiceEventType
  serviceEventId?: string
  serviceTypeId?: string
  statusFacet?: string
  status?: string
  serviceMode?: string
  siteIds?: string[]
}

export type UseOpsStatusesResult = {
  opsLocationStatuses: OpsLocationStatus[],
  isLoading: boolean,
  isFetching: boolean
  refetch?: any,
  error?: ApiError
}

export const useOpsStatuses = (props: UseOpsStatusesProps): UseOpsStatusesResult => {
  const {
    pollingInterval,
    dttm,
    regionId,
    serviceEventType,
    serviceEventId,
    serviceTypeId,
    statusFacet,
    status,
    serviceMode,
    siteIds,
  } = props;

  const selectLocationStatusFacets = useMemo(() => {
    return locationStatusFacetsSelector()
  }, []);

  const {locations, isLoading, isFetching, error, refetch} = useGetLocationStatusFacetsAtTimeQuery(regionId ? {
    dttm: adjustToTimeZoneSafely(dttm)?.getTime(),
    regionId: regionId,
    serviceEventType: serviceEventType,
    serviceEventId: serviceEventId,
    serviceTypeId: serviceTypeId,
    statusFacet: statusFacet,
    status: status,
    serviceMode: serviceMode,
    siteIds: siteIds,
  } : skipToken, {
    pollingInterval: pollingInterval,
    selectFromResult: (result) => ({
      ...result,
      locations: selectLocationStatusFacets(result, {}),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
      error: result.error ? extractApiError(result.error) : undefined,
    })
  });

  const opsLocationStatuses = useMemo(() => {
    return buildOpsLocationStatuses(locations);
  }, [locations])

  return {
    opsLocationStatuses: opsLocationStatuses,
    isLoading: isLoading,
    isFetching: isFetching,
    error: error,
    refetch: refetch,
  };
};
